import { useLocation } from "react-router";

const DataHelper = {
    trimBase64Image: function (image) {
        if (!image) {
            return null;
        }

        if (image.indexOf("base64,") !== -1) {
            return image.split("base64,")[1];
        }

        return image;
    },
    addBase64ToImage: function (image) {
        if (!image) {
            return null;
        }

        if (image.indexOf("base64,") !== -1) {
            return image.split("base64,")[1];
        }

        return `data:image/png;base64,${image}`;
    },
    getFormattedStrDate: function (dateObj, separator = ".") {
        if (dateObj != "Invalid Date") {
            let d = dateObj.getDate() + "";
            if (d.length < 2) {
                d = `0${d}`;
            }

            let m = dateObj.getMonth() + 1;
            if (m < 10) {
                m = `0${m}`;
            }

            let y = dateObj.getFullYear();
            return `${d}${separator}${m}${separator}${y}`;
        }
        return "";
    },
    getFormattedDate: function (isoUTCDateStr, separator = ".") {
        let dateObj = new Date(isoUTCDateStr);
        if (dateObj != "Invalid Date") {
            let d = dateObj.getDate() + "";
            if (d.length < 2) {
                d = `0${d}`;
            }

            let m = dateObj.getMonth() + 1;
            let y = dateObj.getFullYear();
            return `${d}${separator}${m}${separator}${y}`;
        }

        return "";
    },
    getFormattedDateTime: function (isoUTCDateStr) {
        let dateObj = new Date(isoUTCDateStr);
        if (dateObj != "Invalid Date") {
            let d = dateObj.getDate() + "";
            if (d.length < 2) {
                d = `0${d}`;
            }

            let m = dateObj.getMonth() + 1;
            let y = dateObj.getFullYear();
            let t = DataHelper.convertTo12HoursFormat(dateObj);

            return `${d}.${m}.${y} ${t}`;
        }
        return "";
    },
    getFormattedUTCDate: function (localDate) {
        if (localDate != "Invalid Date") {
            let utcDateStr = localDate.toISOString();
            return utcDateStr.split('.')[0] + "+00:00";
        }
        return "";
    },
    getFormattedLocalISODate: function (localDate) {
        if (localDate != "Invalid Date") {
            let d = localDate.getDate() + "";
            if (d.length < 2) {
                d = `0${d}`;
            }

            let m = localDate.getMonth() + 1;
            if (m < 10) {
                m = `0${m}`;
            }
            let y = localDate.getFullYear();
            return `${y}-${m}-${d}T00:00:00+00:00`;
        }

        return "";
    },
    convertTo12HoursFormat(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
}

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default DataHelper;